import styled from "styled-components";
import { Colors } from "../../shared/colors/colors";
import { Fonts } from "../../shared/fonts/fonts";

export type TSchemaButton =
  | "full-primary"
  | "full-wd-primary"
  | "full-secondary"
  | "full-disabled"
  | "x-close"
  | "close-primary"
  | "full-danger"
  | "disabled"
  | "out-primary"
  | "out-secondary"
  | "out-danger"
  | "with-margin";

export type TButton = {
  schemaButton: TSchemaButton;
  position?: string;
  top?: number;
  right?: number;
  left?: number;
};

export const StyledButton = styled.button<TButton>`
  display: flex;
  align-items: center;
  padding: 14px 16px;
  font-family: ${Fonts.primary};
  font-size: 14px;
  font-weight: 500;
  text-align: center;
  justify-content: center;
  border-radius: 8px;
  max-height: 51px;
  max-width: fit-content;
  transition: background-color 0.3s, color 0.3s;
  white-space: nowrap;
  ${(props) => {
    switch (props.schemaButton) {
      case "full-primary":
        return `
          background: ${Colors.primary};
          color: ${Colors.white};
          border: none;
          &:hover {
            background: #1d4ed8;
          }
        `;
      case "full-secondary":
        return `
          background: #6c757d;
          color: #ffffff;
          border: none;
          &:hover {
            background: #5a6268;
          }
        `;
      case "full-wd-primary":
        return `
          max-width: 100%;
          background: ${Colors.primary};
          color: ${Colors.white};
          border: none;
          &:hover {
            background: #1d4ed8;
          }
        `;
      case "full-disabled":
        return `
          background: #2563EB4D;
          color: ${Colors.white};
          border: none;
          &:hover {
            opacity: 0.8;
          }
        `;
      case "x-close":
        return `
          padding: 0;
          background: none;
          border: none;
          color: ${Colors.black};
          ${props.position ? `position: ${props.position};` : ""}
          ${props.top !== undefined ? `top: ${props.top}px;` : ""}
          ${props.right !== undefined ? `right: ${props.right}px;` : ""}
          ${props.left !== undefined ? `left: ${props.left}px;` : ""}
          &:hover {
            color: ${Colors.primary};
          }
        `;
      case "close-primary":
        return `
          background: none;
          border: none;
          color: ${Colors.primary};
          &:hover {
            opacity: 0.8;
          }
        `;
      case "full-danger":
        return `
          background: ${Colors.danger};
          color: ${Colors.white};
          border: none;
          &:hover {
            opacity: 0.8;
          }
        `;
      case "out-primary":
        return `
          background: ${Colors.white};
          color: ${Colors.primary};
          border: 1px solid ${Colors.primary};
          &:hover {
            background: ${Colors.primary};
            color: ${Colors.white};
          }
        `;
      case "out-danger":
        return `
          background:${Colors.white} ;
          color:${Colors.danger};
          border: 1px solid ${Colors.danger};
          &:hover {
            background: ${Colors.danger};
            color:${Colors.white};
          }
        `;
      case "with-margin":
        return `
          background: ${Colors.primary};
          color: ${Colors.white};
          border: none;
          margin-top: 12px;
          &:hover {
            background: #1d4ed8;
          }
        `;
      default:
        break;
    }
  }}

  pointer-events:${(props) => (props.disabled ? "none" : null)};
  background: ${(props) => (props.disabled ? Colors.disabled : null)};
  color: ${(props) => (props.disabled ? Colors.white : null)};
`;
